import styled from 'styled-components';

export const StyledDuplicateLoginStep = styled.div`
  max-width: 420px;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  .content {
    margin-top: 10px;

    .bigger-text {
      font-size: 108%;
      width: 100%;
    }
    .student-name,
    .username {
      color: black;
    }
  }
`;
